<template>
  <div>
    <div class="bodyElement header">
      <h1 class="bigTitle">{{ $t("FederalView.bigTitle2") }}</h1>
    </div>
    <div class="bodyElement">
      <ForecastGraph currentView="FederalView" />
    </div>
  </div>
</template>
<script>
import ForecastGraph from "../components/forecast/ForecastGraph.vue";

export default {
  name: "CanadianElectionForecastView",
  components: {
    ForecastGraph,
  },
};
</script>
<style src="../css/app.css"></style>
